module.exports = __webpack_public_path__ + "static/spielplatz-48277c36ea5694eb5a19c90a6bfa4406.PNG";